import React, { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isCommentReduxReady } from '../../redux/selectors';
import { isCommentHidden } from '../../utils';
import { CommentContext } from '../CommentContext';
export var CommentContextProvider = function (_a) {
    var children = _a.children, comment = _a.comment, hasReplyDraft = _a.hasReplyDraft, onEditingStateChange = _a.onEditingStateChange;
    var isReduxReady = useSelector(isCommentReduxReady);
    var _b = useState('none'), editingState = _b[0], setEditingState = _b[1];
    var _c = useState(false), isPeeking = _c[0], setPeeking = _c[1];
    var _d = useState(true), canShowActionMenu = _d[0], setCanShowActionMenu = _d[1];
    var isCommentVisible = !isCommentHidden(comment, isPeeking);
    var contextState = useMemo(function () { return ({
        comment: comment,
        isEditing: editingState === 'editing',
        isReplying: editingState === 'replying',
        isPeeking: isPeeking,
        isReduxReady: isReduxReady,
        canShowActionMenu: canShowActionMenu,
        isCommentVisible: isCommentVisible,
        setEditingState: function (state) {
            setEditingState(state);
            if (onEditingStateChange) {
                onEditingStateChange(state);
            }
        },
        setPeeking: setPeeking,
        setCanShowActionMenu: setCanShowActionMenu,
    }); }, [
        comment,
        editingState,
        isPeeking,
        isReduxReady,
        isCommentVisible,
        canShowActionMenu,
        onEditingStateChange,
    ]);
    // If there is a reply draft saved, change the editing state to "replying", which
    // will shown a new post box and will in turn restore the saved editor state.
    // This draft is saved on local storage if the user navigates away or closes a page
    // after having written an unsent comment.
    useEffect(function () {
        if (hasReplyDraft) {
            setEditingState('replying');
        }
    }, [hasReplyDraft]);
    return (React.createElement(CommentContext.Provider, { value: contextState }, children));
};
CommentContextProvider.displayName = 'CommentContextProvider';
//# sourceMappingURL=CommentContextProvider.js.map